import { getApi } from 'modules/api';
import endpoints from 'config/endpoints';


export const pageAnalytics = path => dispatch => {
    dispatch(startProcess());
    getApi().post(endpoints.pageAnalytics.endpoint, { path })
        .then(response => {
            dispatch(finishProcess());
        })
        .catch(_error => dispatch(finishProcess()));
};

const ANALYTICS_START_PROCESS = 'ANALYTICS_START_PROCESS';

export const startProcess = () => ({
    type: ANALYTICS_START_PROCESS
});

const ANALYTICS_FINISH_PROCESS = 'ANALYTICS_FINISH_PROCESS';

export const finishProcess = () => ({
    type: ANALYTICS_FINISH_PROCESS
});

const _defaultState = () => ({
    isLoading: false
});

export const reducer = (state = _defaultState(), action = '') => {
    switch (action.type) {
    case ANALYTICS_START_PROCESS:
        return {
            ...state,
            isLoading: true
        };
    case ANALYTICS_FINISH_PROCESS:
        return {
            isLoading: false
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/pageAnalytics.js